import { Spin } from 'antd';

import { Logger } from '@suntex.core/logging';
import { useNavigate } from '@suntex.core/nav';
import { PlayerBadgeSelect } from '@suntex.fim/avatar';
import { useFramework } from '@suntex.fim/framework';
import { showErrorMessage } from '@suntex.fim/ui';

import { usePlayerContext } from '../context';

const logger = Logger.for('BadgePage');

export function BadgePage() {
  const { api } = useFramework();
  const navigate = useNavigate();
  const { playerId, playerInfo, reload: reloadPlayerInfo } = usePlayerContext();

  function saveBadge(icon: number, background: number) {
    return api
      .post_Player_UpdateBadge({ playerId, icon, background })
      .then(() =>
        // Badge was saved successfully; if cache refresh fails we still
        // navigate — the next query cycle will fetch fresh data.
        reloadPlayerInfo().catch((e) => {
          logger.warn(
            'Failed to refresh player info after badge update',
            { playerId },
            e,
          );
        }),
      )
      .then(() => {
        navigate('/player');
      })
      .catch((e: unknown) =>
        showErrorMessage(
          'There was an error in updating your player avatar',
          e,
          { logger },
        ),
      );
  }

  if (!playerInfo) return <Spin />;

  const { stickers, badgeIcon, badgeBackground } = playerInfo.player;

  return (
    <PlayerBadgeSelect
      stickers={stickers}
      icon={badgeIcon}
      background={badgeBackground}
      onSave={saveBadge}
    />
  );
}
